import { DataSourceFormat } from '@/resources/enum';
import { ShapeBaseAttribute } from './base';

export interface TextString {
  // 是否为数据源
  isSource?: boolean;
  // text值或数据源
  value: string;
  color?: string;
  sourceFormat?: DataSourceFormat;
  renderingValue?: string;
}

export class TextWatchfaceAttribute extends ShapeBaseAttribute {
  fontId?: string;
  fontSize = 20;
  fontWeight?: string;

  customFontFile?: string;
  customFontName?: string;
  customFontCropFile?: string;

  /**
   * 文本颜色
   */
  color = '#ffffff';

  /**
   * 文本样式
   */
  style = 'normal';

  /**
   * 文本水平对齐
   */
  align: 'left' | 'center' | 'right' = 'left';

  letterSpace = 0;
  rotation = 0;

  // 行间距
  lineSpace = 0;
  literalTextLength = 8;

  textType: 'slogan' | 'dateWeek' = 'dateWeek';
  texts: string[] = [];

  currentTextIndex = 0;
  longMode?: 'wrap' | 'dot' | 'clip' = 'clip';
}
